// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clsSPTitleHead {
  color: var(--ion-color-label-color);
  text-align: right;
  font-size: 16.45px;
  cursor: pointer;
  font-family: "Roboto Medium";
}

.clsSPTitle {
  text-align: right;
  font-size: 16.45px;
  cursor: pointer;
  margin-top: 30px;
  margin-bottom: 30px;
  font-family: "Roboto Medium";
  color: #8b8d8f;
}

.option_container {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: var(--ion-color-background-color);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  padding: 0px 14px;
}

.search_container {
  padding: 0px;
}

.clsSPTitleSelected {
  font-family: "Roboto Medium";
  text-align: center;
  font-size: 16.45px;
  cursor: pointer;
  border-bottom: 1px solid;
  color: var(--ion-color-heading);
}

.advanceTextCss {
  text-align: right;
  font-size: 16.45px;
  cursor: pointer;
  font-family: "Roboto Medium";
  color: var(--ion-color-primary);
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
}

.textAreaPadding {
  padding-left: 18px;
  padding-right: 2px;
}

.overflow-auto {
  overflow: auto;
}

::-webkit-scrollbar {
  width: 0;
  /* Remove scrollbar space */
  background: transparent;
  /* Optional: just make scrollbar invisible */
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
}

.shape-width-flex .clsShapeImg-new:first-child {
  border: none;
}

.clsShapeImg-new {
  border-left: 1px solid var(--ion-color-secondary);
}

.clsShapeImg-new,
.clsShapeImgSelected-new,
.clsShapeImgSelected-origin {
  max-width: 91px;
  min-width: 50px;
  cursor: pointer;
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}
.clsShapeImg-new .text,
.clsShapeImgSelected-new .text,
.clsShapeImgSelected-origin .text {
  color: #555555;
  padding: 15px 20px;
}

.clsShapeImgSelected-new {
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}
.clsShapeImgSelected-new img {
  padding: 5px;
}
.clsShapeImgSelected-new .text {
  background: var(--ion-color-primary);
  color: #ffffff;
  border: 1px solid #ffffff;
}

.clsShapeImgSelected-origin {
  background: var(--ion-color-primary);
  color: #ffffff;
  border: 1px solid #ffffff;
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}

.clsShapeImg,
.clsShapeImgSelected {
  max-width: 91px;
  min-width: 50px;
  cursor: pointer;
  border: 1px solid var(--ion-color-inner-box-border);
  margin: 4px;
  user-select: none;
  /* supported by Chrome and Opera */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
}
.clsShapeImg .text,
.clsShapeImgSelected .text {
  color: var(--ion-color-inner-heading);
  padding: 5px;
}

.clsShapeImg img {
  padding: 10px;
}

.clsShapeImgSelected img {
  padding: 5px;
}
.clsShapeImgSelected .text {
  background: var(--ion-color-primary);
  color: #ffffff;
}

.srchBox,
.srchBoxSelected {
  border: 1px solid white;
  padding: 20px;
  min-width: 60px;
  cursor: pointer;
  text-align: center;
  color: white;
}

.srchBox {
  background: #73ccd0;
}

.srchBox:hover {
  background: var(--ion-color-primary);
}

.srchBoxSelected {
  background: var(--ion-color-danger);
}

.mt20 {
  margin-top: 20px !important;
}

.girdleSelection {
  width: 75px !important;
  display: inline-block;
  height: 37px;
  /* margin-left: -8px; */
  padding-left: 10px !important;
  margin-top: 2px;
}

::ng-deep .ionic-selectable-value-item {
  text-align: start !important;
}

.savedSearchSelectableMobile {
  width: 64px !important;
  display: inline-block;
  margin-top: 2px;
  height: 37px;
  padding-left: 4px !important;
}

.item-cover {
  height: 0;
  width: 0;
}

.bg-specific {
  background-color: #c0c0c0;
}

.savedSearchSelectable {
  display: inline-block;
  margin-right: 18px;
  height: 37px;
  margin-left: -3px;
  padding-left: 10px !important;
}

.clsSPTitleHeadLeftAlign {
  color: var(--ion-color-primary);
  text-align: left;
  font-size: 16.45px;
  cursor: pointer;
  font-family: "Roboto Medium";
}

.savedSearchSelectable-min {
  max-width: 250px !important;
  display: inline-block;
  margin-right: 18px;
  height: 37px;
  margin-left: -8px;
}

.ddl {
  max-width: 200px;
  display: inline-flex !important;
}

.fromToInput {
  max-width: 75px;
  min-width: 64px;
}

.finishing_parameters_tab {
  display: none;
}

.carat_specific_tab_show {
  display: none;
}

.carat_specific_tab_hide {
  display: inline-block;
}

#dvFancy .clsSPTitleHead,
#finishing_parameters .clsSPTitleHead {
  min-width: 10vw;
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: end;
  margin-right: 10px;
}

#dvFancy .clsSPTitleHead {
  min-width: 6vw;
  color: #000;
  font-weight: 400;
}

@media screen and (max-width: 1700px) {
  .fromToInput {
    max-width: 64px;
  }
  .girdleSelection {
    width: 64px !important;
  }
  .ionic_selectable_container {
    max-width: 64px !important;
    min-width: 64px !important;
  }
}
@media screen and (min-width: 1401px) and (max-width: 1500px) {
  #finishing_parameters .clsSPTitleHead {
    min-width: 7vw;
    width: min-content;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1400px) {
  #finishing_parameters .clsSPTitleHead {
    min-width: 6.8vw;
    width: min-content;
  }
}
.disInline {
  display: inline-flex;
}

.dispContents {
  display: contents !important;
}

.disInline_b {
  display: inline-block !important;
}

.ionic_selectable_container,
.ionic_selectable_container_mob {
  --min-height: 40px !important;
  --max-height: 40px !important;
  height: 40px !important;
  --inner-padding-end: 0px !important;
  max-width: 75px;
  min-width: 75px;
}

.ionic_selectable_container_mob {
  display: inline-block;
  max-width: 68px;
  min-width: 68px;
}

.ionic_selectable_container::part(native) {
  padding: 0px;
  padding-left: 4px;
}

.ionic_selectable_container_mob::part(native) {
  padding: 0px;
}

.round-input {
  --padding-top: 7px !important;
  --padding-end: 8px !important;
  --padding-bottom: 7px !important;
  padding-left: 0px !important;
  text-align: center;
  border: 1px solid var(--ion-color-secondary) !important;
  margin: 2px;
  border-radius: 80px;
  height: 37px;
  color: var(--ion-color-placeholder-color);
}

.input .input-group {
  display: flex;
}

.iconWidth {
  font-size: 30px;
}

.min-width-100 .srchBoxSelected, .min-width-100 .srchBox {
  padding: 5px;
  min-width: 100px;
  height: 35px;
}

.mix-fixed {
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.pad-5-10 {
  padding: 5px 10px !important;
}

.pad-5-6 {
  padding: 5px 6px !important;
}

.mr3 {
  margin: 3px !important;
}

.width-80 {
  width: 80px;
}

.display-flex {
  display: flex;
}

.border-primary {
  border: 1px solid var(--ion-color-primary) !important;
  border-radius: 3px;
}

.border-secondary {
  border: 1px solid var(--ion-color-secondary) !important;
  border-radius: 80px;
}

.white-bg {
  background-color: #ffffff;
}

.border-primary-round {
  border: 1px solid var(--ion-color-primary) !important;
  border-radius: 80px;
}

ionic-selectable {
  color: black;
  text-align: center;
}

.flex-wrap {
  flex-flow: row wrap;
}

@media only screen and (max-width: 500.98px) {
  .onPageTitle {
    font-size: 19px !important;
  }
  .showOnlyWeb {
    display: none;
    visibility: hidden;
  }
  .largeFilters {
    display: none;
    visibility: hidden;
  }
  .smallFilters {
    display: block;
    visibility: visible;
  }
  .contentDiv {
    padding: 0;
  }
}
@media only screen and (min-width: 501px) {
  ion-segment-button {
    min-width: auto;
  }
  .smallFilters {
    display: none;
    visibility: hidden;
  }
  .largeFilters {
    display: block;
    visibility: visible;
  }
}
.filters {
  height: 100%;
  background-color: #f5f5f6;
  padding: 0 0 180px;
}

.selectedFilter {
  --background: #fff;
  font-weight: 500;
  font-size: 14px;
  border-bottom: 1px solid #eaeaec;
}

.itemList {
  --background: #f5f5f6 !important;
  font-size: 14px;
  border-bottom: 1px solid #eaeaec;
}

ion-textarea {
  text-align: center;
  --padding-bottom: -14px !important;
  --padding-start: 0px !important;
  --padding-top: 16px;
  margin-top: 0px;
  height: 54px;
}

.sc-ion-segment-md-h {
  display: -webkit-box;
  overflow: auto;
}

.onPageTitle {
  font-size: 30px;
  font-weight: 500;
  margin-top: 6px;
  margin-bottom: 16px;
  color: var(--ion-color-heading);
  font-family: "Trajan Pro Regular";
}

.ion-contentDiv-md {
  padding-left: 0;
}

.graybg {
  height: 213px;
  background-color: #8b8d8f;
}

.placeholderColor {
  color: var(--ion-color-placeholder-color);
}

.searchCard {
  display: block;
  float: right;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 2px 21px -7px #b9b7b7;
  margin: 0px 0px 0px 10px;
  background: var(--ion-color-background-color);
  color: var(--ion-color-text-color);
}

.contentDiv {
  padding-left: 4.15vw;
  padding-right: 4.15vw;
}

.clear-btn {
  font-size: 10px;
  float: left;
  margin-top: 0px;
  color: #4d5258;
}

.search-btn {
  position: fixed;
  bottom: 20px;
}

::ng-deep .ionic-selectable-value {
  padding-top: 9px !important;
  text-align: center;
}

.scrollmenu {
  overflow: auto;
}

.shape-width {
  display: block;
  border-radius: 18px;
  overflow: hidden;
  border: 0.5px solid var(--ion-color-secondary);
  padding: 10px;
}

.shape-width-flex {
  width: 82vw;
  display: flex;
  margin: auto;
  overflow: overlay;
  border: 0.3px solid var(--ion-color-secondary);
}

.left-color-div {
  width: 197px;
  height: 45px;
  line-height: 45px;
  border-radius: 25px 0 0 0px;
  border: 2px solid var(--ion-color-primary) !important;
  float: right;
  text-align: center;
}

.right-color-div {
  width: 197px;
  height: 45px;
  line-height: 45px;
  border-radius: 0 25px 0 0;
  border: 2px solid var(--ion-color-primary) !important;
  float: left;
  text-align: center;
}

.clsSPTitle-min {
  font-size: 16.45px;
  cursor: pointer;
  font-family: "Roboto Medium";
  color: var(--ion-color-secondary) !important;
}

.clsSPTitleSelected-min {
  font-family: "Roboto Medium";
  font-size: 16.45px;
  cursor: pointer;
  color: white;
  background-color: var(--ion-color-primary);
}

.mr35 {
  margin-right: 35px;
}

.rounded-flex {
  width: 82vw;
  display: flex;
  margin: auto;
}

.mlr {
  margin-left: 40px;
  margin-right: 30px;
}

.shape-box {
  font-size: 16px;
  line-height: 16px;
  overflow: hidden;
}

.show {
  overflow: visible;
  height: auto;
}

.more-btn {
  color: #555555;
  font-size: 16px;
  margin: auto;
  text-decoration: none;
}

.footer-btn {
  height: 65px;
  text-decoration: none;
}

.fixed-row {
  position: fixed;
  bottom: 20px;
  width: 90vw;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  z-index: 1000000;
}

.pdbtn {
  margin-bottom: 50px;
}

.shape-text {
  padding: 12px;
}

.search-fixed-row {
  border-radius: 20px;
  box-shadow: 0px 2px 26px -6px #b9b7b7;
  text-align: right;
}

.inner-box {
  text-align: center;
  padding: 0;
  border: 1px solid var(--ion-color-secondary) !important;
  border-radius: 80px;
}

.to-text {
  padding-top: 10px;
}

.mobile-bg {
  --background: #ececec !important;
}

.small-font {
  font-size: 14px !important;
}

.int-outerdiv {
  width: 82vw;
  margin: auto;
  display: block;
  border-radius: 0 0 18px 18px;
  overflow: hidden;
  border: 0.5px solid var(--ion-color-secondary);
  padding: 10px px;
}

.searchBtnHeight {
  height: 65px !important;
}

.header-diamond {
  height: 3vh;
  margin-top: 4px;
  margin-right: 16px;
}

.header-diamond-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

@media only screen and (max-width: 768px) {
  .header-diamond-image {
    height: auto; /* Adjust as necessary */
    min-height: 2.7vh; /* Ensure it takes full screen height */
  }
}
.plain-text {
  color: white;
  font-size: 3.5vh;
  font-weight: bolder;
  font-family: "Trajan Pro Regular";
}

.s-icon {
  color: var(--ion-color-primary) !important;
}

.colored-text {
  color: var(--ion-color-primary) !important;
  font-size: 2.1vh;
  margin-left: 20px;
}

.delete-search {
  color: var(--ion-color-primary) !important;
  font-size: 2.1vh;
}

.disabledDivBtn {
  background: #ddd !important;
}

.bottom-line {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1019607843);
  padding: 10px 0px;
}

.reset_btn {
  color: var(--ion-color-label-color);
  --background: var(--ion-color-background-button);
}

.fixedWidthBtn {
  width: 8.5vw;
}

@media (min-width: 992px) and (max-width: 1240px) {
  .fixedWidthBtn {
    width: 12vw !important;
  }
  .finishing_parameters_tab {
    display: block;
  }
  .finishing_parameters_desc {
    display: none;
  }
  .carat_specific_tab_show {
    display: inline-block;
  }
  .carat_specific_tab_hide {
    display: none;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  .fixedWidthBtn {
    width: 16vw !important;
  }
  .contentDiv {
    padding: 0px 2vw 20px 2vw;
  }
  .onPageTitle {
    font-size: 28px;
    font-weight: 400;
    margin-top: 16px;
    margin-bottom: 10px;
  }
  .clsSPTitleHead {
    font-size: 14px;
    font-weight: 500;
    margin-right: 8px;
  }
  .clsSPTitle {
    font-size: 14px;
    font-weight: 500;
    margin-left: 4px;
  }
  .clsSPTitleSelected {
    font-size: 14px;
    font-weight: 500;
    margin-right: 4px;
  }
  .bottom-line {
    padding: 0px;
  }
  .search_textarea {
    height: 42px;
    width: 30vw;
  }
  ::ng-deep .search_textarea .textarea-wrapper .native-textarea {
    padding: 10px 0px 0px !important;
    height: 40px;
  }
  .clsShapeImg .text,
  .clsShapeImgSelected .text {
    padding: 4px 12px !important;
    font-size: 14px;
  }
  .searchCard_content {
    padding: 12px 12px 12px 12px !important;
  }
  .finishing_parameters_tab {
    display: block;
  }
  .finishing_parameters_desc {
    display: none;
  }
  .carat_specific_tab_show {
    display: inline-block;
  }
  .carat_specific_tab_hide {
    display: none;
  }
  #finishing_parameters .clsSPTitleHead {
    min-width: 9vw;
    width: min-content;
  }
  .finishing_extra {
    display: none;
  }
  .advanceTextCss {
    font-size: 16px;
  }
  .option_container {
    padding: 12px;
  }
  .bg-specific {
    width: 100px;
  }
  .carat_specific_added .text {
    padding: 6px 20px 6px 8px !important;
    font-size: 12px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  #finishing_parameters .clsSPTitleHead {
    min-width: 12vw;
    width: min-content;
  }
  .searchCard {
    margin: 20px 0px 60px 0px;
  }
  .search-btn {
    right: 22px;
  }
  .fixedWidthBtn {
    width: auto;
  }
}
@media (min-width: 501px) and (max-width: 575px) {
  .searchCard {
    margin: 20px 0px 60px 0px;
  }
  .search-btn {
    right: 34px;
  }
  .fixedWidthBtn {
    width: auto;
  }
  .disInline_direction {
    flex-direction: column;
  }
  #finishing_parameters .clsSPTitleHead {
    min-width: 21vw;
  }
}
.reset-img {
  background-image: url('reset.png');
  background-position: center;
  background-size: auto;
  background-repeat: no-repeat;
}

.clearBtnWithImage {
  cursor: pointer;
}

.round-reset-btn {
  border-radius: 80px;
  height: 32px;
  margin-top: 8px;
  margin-right: 8px;
  background: var(--ion-color-primary, #3880ff);
}

.savedSearchtitle {
  font-size: 15px;
  font-weight: 600;
  color: var(--ion-color-heading);
  font-family: "Trajan Pro Regular";
}

.reset-icon {
  font-size: 25px;
}

@media (min-width: 0px) and (max-width: 575px) {
  .left-color-div,
  .right-color-div {
    line-height: 34px;
  }
  .int-outerdiv {
    border: 0px solid;
  }
  .shape-width-flex {
    border-radius: 12px;
    border: 1px solid var(--ion-color-secondary);
  }
  .shape-width-flex_mob {
    border-radius: 0px 0px 25px 25px;
    border: 1px solid var(--ion-color-secondary);
  }
  .shape-width-flex_mob::-webkit-scrollbar {
    height: 0px;
  }
  .shape-width-flex::-webkit-scrollbar {
    height: 0px;
  }
}
.group_container::-webkit-scrollbar {
  height: 0px;
}

.carat_specific_add_btn {
  --border-radius: 50%;
  margin: 6px;
  width: 40px;
  height: 40px;
}

.carat_specific_added {
  margin: 8px 4px;
  position: relative;
}

.carat_specific_added .text {
  padding: 6px 20px 6px 8px !important;
  font-size: 12px;
}

.remove-specific-carat {
  color: #fff;
  font-size: 16px;
  position: absolute;
  right: -2px;
  top: 2px;
  padding: 4px;
}

::ng-deep .ionic-selectable-value span {
  display: flex;
  gap: 4px;
}

.to-from_input,
.to-from_input-mob {
  padding: 0px !important;
  text-align: center;
}

::ng-deep .to-from_input-mob .native-input.sc-ion-input-ios {
  padding-left: 8px;
}

ion-toolbar {
  --padding-start: 0px;
  --padding-end: 0px;
  --padding-top: 0px;
  --padding-bottom: 0px;
}

.footer-ios ion-toolbar:first-of-type {
  border-top: none !important; /* Removes the border at the bottom */
  --border-width: 0 !important; /* Ensure that any Ionic-specific border styles are also removed */
}

@media screen and (max-width: 575px) {
  ::ng-deep ionic-selectable .ionic-selectable-inner .ionic-selectable-value {
    display: flex;
    justify-content: center;
  }
  ::ng-deep ionic-selectable .ionic-selectable-inner .ionic-selectable-icon {
    position: absolute;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/diamond-search/diamond-searched-params/diamond-searched-params.component.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,oCAAA;EACA,6CAAA;EACA,gDAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,+BAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EAGA,4BAAA;EACA,+BAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,4CAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,iDAAA;AADF;;AAIA;;;EAGE,eAAA;EACA,eAAA;EACA,eAAA;EAOA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AAPF;AAPE;;;EACE,cAAA;EACA,kBAAA;AAWJ;;AAUA;EAcE,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AApBF;AAFE;EACE,YAAA;AAIJ;AADE;EAIE,oCAAA;EACA,cAAA;EACA,yBAAA;AAAJ;;AAeA;EACE,oCAAA;EACA,cAAA;EACA,yBAAA;EAEA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AAbF;;AAgBA;;EAEE,eAAA;EACA,eAAA;EACA,eAAA;EACA,mDAAA;EAOA,WAAA;EACA,iBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AAnBF;AAIE;;EACE,qCAAA;EACA,YAAA;AADJ;;AAoBE;EACE,aAAA;AAjBJ;;AA4BE;EACE,YAAA;AAzBJ;AA4BE;EACE,oCAAA;EACA,cAAA;AA1BJ;;AA8BA;;EAEE,uBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA3BF;;AA8BA;EACE,mBAAA;AA3BF;;AA8BA;EACE,oCAAA;AA3BF;;AA8BA;EACE,mCAAA;AA3BF;;AA8BA;EACE,2BAAA;AA3BF;;AA8BA;EACE,sBAAA;EACA,qBAAA;EAEA,YAAA;EACA,uBAAA;EACA,6BAAA;EAEA,eAAA;AA7BF;;AAgCA;EACE,4BAAA;AA7BF;;AAgCA;EACE,sBAAA;EACA,qBAAA;EAEA,eAAA;EACA,YAAA;EAGA,4BAAA;AAhCF;;AAmCA;EACE,SAAA;EACA,QAAA;AAhCF;;AAmCA;EACE,yBAAA;AAhCF;;AAmCA;EAEE,qBAAA;EACA,kBAAA;EACA,YAAA;EAEA,iBAAA;EACA,6BAAA;AAlCF;;AA8CA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AA3CF;;AA8CA;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EAEA,iBAAA;AA5CF;;AA+CA;EACE,gBAAA;EACA,+BAAA;AA5CF;;AA+CA;EACE,eAAA;EACA,eAAA;AA5CF;;AA+CA;EACE,aAAA;AA5CF;;AA+CA;EACE,aAAA;AA5CF;;AA+CA;EACE,qBAAA;AA5CF;;AA+CA;;EAEE,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;AA5CF;;AA+CA;EACE;IACE,eAAA;EA5CF;EA+CA;IACE,sBAAA;EA7CF;EAgDA;IACE,0BAAA;IACA,0BAAA;EA9CF;AACF;AAiDA;EACE;IACE,cAAA;IACA,kBAAA;EA/CF;AACF;AAkDA;EACE;IACE,gBAAA;IACA,kBAAA;EAhDF;AACF;AAmDA;EACE,oBAAA;AAjDF;;AAoDA;EACE,4BAAA;AAjDF;;AAoDA;EACE,gCAAA;AAjDF;;AAoDA;;EAEE,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,eAAA;AAjDF;;AAoDA;EACE,qBAAA;EACA,eAAA;EACA,eAAA;AAjDF;;AAoDA;EACE,YAAA;EACA,iBAAA;AAjDF;;AAoDA;EACE,YAAA;AAjDF;;AAoDA;EACE,6BAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,kBAAA;EACA,uDAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,yCAAA;AAjDF;;AAqDE;EACE,aAAA;AAlDJ;;AAsDA;EACE,eAAA;AAnDF;;AAuDE;EAEE,YAAA;EACA,gBAAA;EACA,YAAA;AArDJ;;AAyDA;EACE,2BAAA;EAAA,sBAAA;AAtDF;;AAyDA;EACE,4BAAA;AAtDF;;AAyDA;EACE,2BAAA;AAtDF;;AAyDA;EACE,sBAAA;AAtDF;;AAyDA;EACE,WAAA;AAtDF;;AAyDA;EACE,aAAA;AAtDF;;AAyDA;EACE,qDAAA;EACA,kBAAA;AAtDF;;AAyDA;EACE,uDAAA;EACA,mBAAA;AAtDF;;AAyDA;EACE,yBAAA;AAtDF;;AAyDA;EACE,qDAAA;EACA,mBAAA;AAtDF;;AAyDA;EACE,YAAA;EACA,kBAAA;AAtDF;;AAyDA;EACE,mBAAA;AAtDF;;AAyDA;EACE;IACE,0BAAA;EAtDF;EAyDA;IACE,aAAA;IACA,kBAAA;EAvDF;EAgEA;IACE,aAAA;IACA,kBAAA;EA9DF;EAiEA;IACE,cAAA;IACA,mBAAA;EA/DF;EAkEA;IACE,UAAA;EAhEF;AACF;AAmEA;EACE;IACE,eAAA;EAjEF;EAoEA;IACE,aAAA;IACA,kBAAA;EAlEF;EAqEA;IACE,cAAA;IACA,mBAAA;EAnEF;AACF;AAsEA;EACE,YAAA;EAEA,yBAAA;EACA,kBAAA;AArEF;;AAwEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AArEF;;AAwEA;EACE,gCAAA;EACA,eAAA;EACA,gCAAA;AArEF;;AAwEA;EACE,kBAAA;EACA,kCAAA;EACA,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,cAAA;AArEF;;AAwEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,iCAAA;AArEF;;AAwEA;EACE,eAAA;AArEF;;AAwEA;EACE,aAAA;EACA,yBAAA;AArEF;;AA6EA;EACE,yCAAA;AA1EF;;AA4EA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;AAzEF;;AA4EA;EAEE,oBAAA;EACA,qBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,YAAA;AA1EF;;AA6EA;EACE,2BAAA;EACA,kBAAA;AA1EF;;AAiFA;EACE,cAAA;AA9EF;;AAiFA;EACE,cAAA;EAGA,mBAAA;EAEA,gBAAA;EACA,8CAAA;EAIA,aAAA;AApFF;;AAuFA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EAEA,iBAAA;EACA,8CAAA;AArFF;;AAwFA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,qDAAA;EACA,YAAA;EACA,kBAAA;AArFF;;AAwFA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,qDAAA;EACA,WAAA;EACA,kBAAA;AArFF;;AAwFA;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,4CAAA;AArFF;;AAwFA;EACE,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,0CAAA;AArFF;;AAwFA;EACE,kBAAA;AArFF;;AAwFA;EACE,WAAA;EACA,aAAA;EACA,YAAA;AArFF;;AAyFA;EACE,iBAAA;EACA,kBAAA;AAtFF;;AAyFA;EACE,eAAA;EACA,iBAAA;EAEA,gBAAA;AAvFF;;AA0FA;EACE,iBAAA;EACA,YAAA;AAvFF;;AA0FA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AAvFF;;AA0FA;EACE,YAAA;EACA,qBAAA;AAvFF;;AA0FA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EAGA,gBAAA;AAzFF;;AA4FA;EACE,mBAAA;AAzFF;;AA4FA;EACE,aAAA;AAzFF;;AA4FA;EACE,mBAAA;EAGA,qCAAA;EACA,iBAAA;AAzFF;;AA4FA;EACE,kBAAA;EACA,UAAA;EACA,uDAAA;EACA,mBAAA;AAzFF;;AA4FA;EACE,iBAAA;AAzFF;;AA4FA;EAEE,gCAAA;AA1FF;;AA6FA;EACE,0BAAA;AA1FF;;AA6FA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;EACA,gBAAA;EACA,8CAAA;EACA,gBAAA;AA1FF;;AA6FA;EACE,uBAAA;AA1FF;;AA6FA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AA1FF;;AA6FA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AA1FF;;AA6FA;EACE;IACE,YAAA,EAAA,wBAAA;IACA,iBAAA,EAAA,uCAAA;EA1FF;AACF;AA6FA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AA3FF;;AA8FA;EACE,0CAAA;AA3FF;;AA8FA;EACE,0CAAA;EACA,gBAAA;EACA,iBAAA;AA3FF;;AA8FA;EACE,0CAAA;EACA,gBAAA;AA3FF;;AA8FA;EACE,2BAAA;AA3FF;;AA8FA;EACE,oDAAA;EACA,iBAAA;AA3FF;;AA8FA;EACE,mCAAA;EACA,gDAAA;AA3FF;;AA+FA;EACE,YAAA;AA5FF;;AAsHA;EACE;IACE,sBAAA;EAnHF;EAsHA;IACE,cAAA;EApHF;EAuHA;IACE,aAAA;EArHF;EAwHA;IACE,qBAAA;EAtHF;EAyHA;IACE,aAAA;EAvHF;AACF;AA0HA;EACE;IACE,sBAAA;EAxHF;EA2HA;IACE,yBAAA;EAzHF;EA4HA;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EA1HF;EA6HA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA3HF;EA8HA;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;EA5HF;EA+HA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EA7HF;EAgIA;IACE,YAAA;EA9HF;EAiIA;IACE,YAAA;IACA,WAAA;EA/HF;EAkIA;IACE,gCAAA;IACA,YAAA;EAhIF;EAqIE;;IACE,4BAAA;IACA,eAAA;EAlIJ;EA0IA;IACE,uCAAA;EAxIF;EA2IA;IACE,cAAA;EAzIF;EA4IA;IACE,aAAA;EA1IF;EA6IA;IACE,qBAAA;EA3IF;EA8IA;IACE,aAAA;EA5IF;EA+IA;IACE,cAAA;IACA,kBAAA;EA7IF;EAgJA;IACE,aAAA;EA9IF;EAiJA;IACE,eAAA;EA/IF;EAkJA;IACE,aAAA;EAhJF;EAmJA;IACE,YAAA;EAjJF;EAoJA;IACE,oCAAA;IACA,eAAA;EAlJF;AACF;AAqJA;EACE;IACE,eAAA;IACA,kBAAA;EAnJF;EAsJA;IACE,yBAAA;EApJF;EAuJA;IACE,WAAA;EArJF;EAwJA;IACE,WAAA;EAtJF;AACF;AAyJA;EACE;IACE,yBAAA;EAvJF;EA0JA;IACE,WAAA;EAxJF;EA2JA;IACE,WAAA;EAzJF;EA4JA;IACE,sBAAA;EA1JF;EA6JA;IACE,eAAA;EA3JF;AACF;AA8JA;EACE,kCAAA;EACA,2BAAA;EACA,qBAAA;EACA,4BAAA;AA5JF;;AAmKA;EACE,eAAA;AAhKF;;AAmKA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;AAhKF;;AAmKA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iCAAA;AAhKF;;AAmKA;EACE,eAAA;AAhKF;;AAmKA;EACE;;IAEE,iBAAA;EAhKF;EAmKA;IACE,iBAAA;EAjKF;EAoKA;IACE,mBAAA;IACA,4CAAA;EAlKF;EAqKA;IACE,gCAAA;IACA,4CAAA;EAnKF;EAsKA;IACE,WAAA;EApKF;EAuKA;IACE,WAAA;EArKF;AACF;AAwKA;EACE,WAAA;AAtKF;;AAyKA;EACE,oBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAtKF;;AAyKA;EACE,eAAA;EACA,kBAAA;AAtKF;;AAyKA;EACE,oCAAA;EACA,eAAA;AAtKF;;AAyKA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;AAtKF;;AAyKA;EACE,aAAA;EACA,QAAA;AAtKF;;AAyKA;;EAEE,uBAAA;EACA,kBAAA;AAtKF;;AAyKA;EACE,iBAAA;AAtKF;;AAyKA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAtKF;;AAyKA;EACE,2BAAA,EAAA,qCAAA;EACA,4BAAA,EAAA,kEAAA;AAtKF;;AAwKA;EAGM;IACE,aAAA;IACA,uBAAA;EAvKN;EA0KI;IACE,kBAAA;EAxKN;AACF","sourcesContent":[".clsSPTitleHead {\n  color: var(--ion-color-label-color);\n  text-align: right;\n  font-size: 16.45px;\n  cursor: pointer;\n  font-family: 'Roboto Medium';\n}\n\n.clsSPTitle {\n  text-align: right;\n  font-size: 16.45px;\n  cursor: pointer;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  font-family: 'Roboto Medium';\n  color: #8b8d8f;\n}\n\n.option_container {\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  background: var(--ion-color-background-color);\n  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);\n  padding: 0px 14px;\n}\n\n.search_container {\n  padding: 0px;\n}\n\n.clsSPTitleSelected {\n  font-family: 'Roboto Medium';\n  text-align: center;\n  font-size: 16.45px;\n  cursor: pointer;\n  border-bottom: 1px solid;\n  color: var(--ion-color-heading);\n}\n\n.advanceTextCss {\n  text-align: right;\n  font-size: 16.45px;\n  cursor: pointer;\n  // margin-top: 8px;\n  // margin-bottom: 30px;\n  font-family: 'Roboto Medium';\n  color: var(--ion-color-primary);\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: center;\n}\n\n.textAreaPadding {\n  padding-left: 18px;\n  padding-right: 2px;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n::-webkit-scrollbar {\n  width: 0;\n  /* Remove scrollbar space */\n  background: transparent;\n  /* Optional: just make scrollbar invisible */\n}\n\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n}\n\n.shape-width-flex .clsShapeImg-new:first-child {\n  border: none;\n}\n\n.clsShapeImg-new {\n  border-left: 1px solid var(--ion-color-secondary);\n}\n\n.clsShapeImg-new,\n.clsShapeImgSelected-new,\n.clsShapeImgSelected-origin {\n  max-width: 91px;\n  min-width: 50px;\n  cursor: pointer;\n\n  .text {\n    color: #555555;\n    padding: 15px 20px;\n  }\n\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n.clsShapeImg-new:hover {\n  .text {\n    //background: var(--ion-color-secondary);\n  }\n}\n\n.clsShapeImgSelected-new {\n  img {\n    padding: 5px;\n  }\n\n  .text {\n    // border: 1px solid var(--ion-color-primary);\n    // color: var(--ion-color-primary);\n    // box-shadow:0px 0px 0px 2px var(--ion-color-primary)inset;\n    background: var(--ion-color-primary);\n    color: #ffffff;\n    border: 1px solid #ffffff;\n  }\n\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n.clsShapeImgSelected-origin {\n  background: var(--ion-color-primary);\n  color: #ffffff;\n  border: 1px solid #ffffff;\n\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n}\n\n.clsShapeImg,\n.clsShapeImgSelected {\n  max-width: 91px;\n  min-width: 50px;\n  cursor: pointer;\n  border: 1px solid var(--ion-color-inner-box-border);\n\n  .text {\n    color: var(--ion-color-inner-heading);\n    padding: 5px;\n  }\n\n  margin: 4px;\n  user-select: none;\n  /* supported by Chrome and Opera */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  // margin: auto;\n  // padding: 5px;\n}\n\n.clsShapeImg {\n  img {\n    padding: 10px;\n  }\n}\n\n.clsShapeImg:hover {\n  .text {\n    // background: var(--ion-color-secondary);\n  }\n}\n\n.clsShapeImgSelected {\n  img {\n    padding: 5px;\n  }\n\n  .text {\n    background: var(--ion-color-primary);\n    color: #ffffff;\n  }\n}\n\n.srchBox,\n.srchBoxSelected {\n  border: 1px solid white;\n  padding: 20px;\n  min-width: 60px;\n  cursor: pointer;\n  text-align: center;\n  color: white;\n}\n\n.srchBox {\n  background: #73ccd0;\n}\n\n.srchBox:hover {\n  background: var(--ion-color-primary);\n}\n\n.srchBoxSelected {\n  background: var(--ion-color-danger);\n}\n\n.mt20 {\n  margin-top: 20px !important;\n}\n\n.girdleSelection {\n  width: 75px !important;\n  display: inline-block;\n  // margin-right: 18px;\n  height: 37px;\n  /* margin-left: -8px; */\n  padding-left: 10px !important;\n  // margin-left: 4px;\n  margin-top: 2px;\n}\n\n::ng-deep .ionic-selectable-value-item {\n  text-align: start !important;\n}\n\n.savedSearchSelectableMobile {\n  width: 64px !important;\n  display: inline-block;\n  //margin-left: 4px;\n  margin-top: 2px;\n  height: 37px;\n  //margin-top: 20px;\n  //margin-left: 18px;\n  padding-left: 4px !important;\n}\n\n.item-cover {\n  height: 0;\n  width: 0;\n}\n\n.bg-specific {\n  background-color: #c0c0c0;\n}\n\n.savedSearchSelectable {\n  // max-width: 250px !important;\n  display: inline-block;\n  margin-right: 18px;\n  height: 37px;\n  //margin-top: 20px;\n  margin-left: -3px;\n  padding-left: 10px !important;\n}\n\n// ::ng-deep\n//   .savedSearchSelectable\n//   .ionic-selectable-inner\n//   .ionic-selectable-cover {\n//   height: 36% !important;\n//   position: absolute !important;\n//   top: 84px !important;\n// }\n\n.clsSPTitleHeadLeftAlign {\n  color: var(--ion-color-primary);\n  text-align: left;\n  font-size: 16.45px;\n  cursor: pointer;\n  font-family: 'Roboto Medium';\n}\n\n.savedSearchSelectable-min {\n  max-width: 250px !important;\n  display: inline-block;\n  margin-right: 18px;\n  height: 37px;\n  //margin-top: 20px;\n  margin-left: -8px;\n}\n\n.ddl {\n  max-width: 200px;\n  display: inline-flex !important;\n}\n\n.fromToInput {\n  max-width: 75px;\n  min-width: 64px;\n}\n\n.finishing_parameters_tab {\n  display: none;\n}\n\n.carat_specific_tab_show {\n  display: none;\n}\n\n.carat_specific_tab_hide {\n  display: inline-block;\n}\n\n#dvFancy .clsSPTitleHead,\n#finishing_parameters .clsSPTitleHead {\n  min-width: 10vw;\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: end;\n  margin-right: 10px;\n}\n\n#dvFancy .clsSPTitleHead {\n  min-width: 6vw;\n  color: #000;\n  font-weight: 400;\n}\n\n@media screen and (max-width: 1700px) {\n  .fromToInput {\n    max-width: 64px;\n  }\n\n  .girdleSelection {\n    width: 64px !important;\n  }\n\n  .ionic_selectable_container {\n    max-width: 64px !important;\n    min-width: 64px !important;\n  }\n}\n\n@media screen and (min-width: 1401px) and (max-width: 1500px) {\n  #finishing_parameters .clsSPTitleHead {\n    min-width: 7vw;\n    width: min-content;\n  }\n}\n\n@media screen and (min-width: 1201px) and (max-width: 1400px) {\n  #finishing_parameters .clsSPTitleHead {\n    min-width: 6.8vw;\n    width: min-content;\n  }\n}\n\n.disInline {\n  display: inline-flex;\n}\n\n.dispContents {\n  display: contents !important;\n}\n\n.disInline_b {\n  display: inline-block !important;\n}\n\n.ionic_selectable_container,\n.ionic_selectable_container_mob {\n  --min-height: 40px !important;\n  --max-height: 40px !important;\n  height: 40px !important;\n  --inner-padding-end: 0px !important;\n  max-width: 75px;\n  min-width: 75px;\n}\n\n.ionic_selectable_container_mob {\n  display: inline-block;\n  max-width: 68px;\n  min-width: 68px;\n}\n\n.ionic_selectable_container::part(native) {\n  padding: 0px;\n  padding-left: 4px;\n}\n\n.ionic_selectable_container_mob::part(native) {\n  padding: 0px;\n}\n\n.round-input {\n  --padding-top: 7px !important;\n  --padding-end: 8px !important;\n  --padding-bottom: 7px !important;\n  padding-left: 0px !important;\n  text-align: center;\n  border: 1px solid var(--ion-color-secondary) !important;\n  margin: 2px;\n  border-radius: 80px;\n  height: 37px;\n  color: var(--ion-color-placeholder-color);\n}\n\n.input {\n  .input-group {\n    display: flex;\n  }\n}\n\n.iconWidth {\n  font-size: 30px;\n}\n\n.min-width-100 {\n  & .srchBoxSelected,\n  & .srchBox {\n    padding: 5px;\n    min-width: 100px;\n    height: 35px;\n  }\n}\n\n.mix-fixed {\n  min-width: fit-content;\n}\n\n.pad-5-10 {\n  padding: 5px 10px !important;\n}\n\n.pad-5-6 {\n  padding: 5px 6px !important;\n}\n\n.mr3 {\n  margin: 3px !important;\n}\n\n.width-80 {\n  width: 80px;\n}\n\n.display-flex {\n  display: flex;\n}\n\n.border-primary {\n  border: 1px solid var(--ion-color-primary) !important;\n  border-radius: 3px;\n}\n\n.border-secondary {\n  border: 1px solid var(--ion-color-secondary) !important;\n  border-radius: 80px;\n}\n\n.white-bg {\n  background-color: #ffffff;\n}\n\n.border-primary-round {\n  border: 1px solid var(--ion-color-primary) !important;\n  border-radius: 80px;\n}\n\nionic-selectable {\n  color: black;\n  text-align: center;\n}\n\n.flex-wrap {\n  flex-flow: row wrap;\n}\n\n@media only screen and (max-width: 500.98px) {\n  .onPageTitle {\n    font-size: 19px !important;\n  }\n\n  .showOnlyWeb {\n    display: none;\n    visibility: hidden;\n  }\n\n  // .clsSPTitleSelected{\n  //   font-size: 9px !important;\n  // }\n  // .clsSPTitle{\n  //   font-size: 9px !important;\n  // }\n  .largeFilters {\n    display: none;\n    visibility: hidden;\n  }\n\n  .smallFilters {\n    display: block;\n    visibility: visible;\n  }\n\n  .contentDiv {\n    padding: 0;\n  }\n}\n\n@media only screen and (min-width: 501px) {\n  ion-segment-button {\n    min-width: auto;\n  }\n\n  .smallFilters {\n    display: none;\n    visibility: hidden;\n  }\n\n  .largeFilters {\n    display: block;\n    visibility: visible;\n  }\n}\n\n.filters {\n  height: 100%;\n  // overflow: scroll;\n  background-color: #f5f5f6;\n  padding: 0 0 180px;\n}\n\n.selectedFilter {\n  --background: #fff;\n  font-weight: 500;\n  font-size: 14px;\n  border-bottom: 1px solid #eaeaec;\n}\n\n.itemList {\n  --background: #f5f5f6 !important;\n  font-size: 14px;\n  border-bottom: 1px solid #eaeaec;\n}\n\nion-textarea {\n  text-align: center;\n  --padding-bottom: -14px !important;\n  --padding-start: 0px !important;\n  --padding-top: 16px;\n  margin-top: 0px;\n  height: 54px;\n}\n\n.sc-ion-segment-md-h {\n  display: -webkit-box;\n  overflow: auto;\n}\n\n.onPageTitle {\n  font-size: 30px;\n  font-weight: 500;\n  margin-top: 6px;\n  margin-bottom: 16px;\n  color: var(--ion-color-heading);\n  font-family: 'Trajan Pro Regular';\n}\n\n.ion-contentDiv-md {\n  padding-left: 0;\n}\n\n.graybg {\n  height: 213px;\n  background-color: #8b8d8f;\n}\n\n// .largeFilters {\n//   ion-row {\n//     margin-bottom: 10px;\n//   }\n// }\n.placeholderColor {\n  color: var(--ion-color-placeholder-color);\n}\n.searchCard {\n  display: block;\n  float: right;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0px 2px 21px -7px #b9b7b7;\n  margin: 0px 0px 0px 10px;\n  background: var(--ion-color-background-color);\n  color: var(--ion-color-text-color);\n}\n\n.contentDiv {\n  // background-color: var(--ion-color-background-color);\n  padding-left: 4.15vw;\n  padding-right: 4.15vw;\n}\n\n.clear-btn {\n  font-size: 10px;\n  float: left;\n  margin-top: 0px;\n  color: #4d5258;\n}\n\n.search-btn {\n  position: fixed;\n  bottom: 20px;\n}\n\n::ng-deep .ionic-selectable-value {\n  padding-top: 9px !important;\n  text-align: center;\n}\n\n.side-search-card {\n  // width: 50vw;\n}\n\n.scrollmenu {\n  overflow: auto;\n}\n\n.shape-width {\n  display: block;\n  //margin-left: 100px;\n  // border-radius: 0px 0px 18px 18px;\n  border-radius: 18px;\n\n  overflow: hidden;\n  border: 0.5px solid var(--ion-color-secondary);\n  // -webkit-box-shadow: 0px 2px 26px -6px #b9b7b7;\n  // -moz-box-shadow: 0px 2px 26px -6px #b9b7b7;\n  // box-shadow: 0px 2px 26px -6px #b9b7b7;\n  padding: 10px;\n}\n\n.shape-width-flex {\n  width: 82vw;\n  display: flex;\n  margin: auto;\n  //margin-left: 39px;\n  overflow: overlay;\n  border: 0.3px solid var(--ion-color-secondary);\n}\n\n.left-color-div {\n  width: 197px;\n  height: 45px;\n  line-height: 45px;\n  border-radius: 25px 0 0 0px;\n  border: 2px solid var(--ion-color-primary) !important;\n  float: right;\n  text-align: center;\n}\n\n.right-color-div {\n  width: 197px;\n  height: 45px;\n  line-height: 45px;\n  border-radius: 0 25px 0 0;\n  border: 2px solid var(--ion-color-primary) !important;\n  float: left;\n  text-align: center;\n}\n\n.clsSPTitle-min {\n  font-size: 16.45px;\n  cursor: pointer;\n  font-family: 'Roboto Medium';\n  color: var(--ion-color-secondary) !important;\n}\n\n.clsSPTitleSelected-min {\n  font-family: 'Roboto Medium';\n  font-size: 16.45px;\n  cursor: pointer;\n  color: white;\n  background-color: var(--ion-color-primary);\n}\n\n.mr35 {\n  margin-right: 35px;\n}\n\n.rounded-flex {\n  width: 82vw;\n  display: flex;\n  margin: auto;\n  // overflow: scroll;\n}\n\n.mlr {\n  margin-left: 40px;\n  margin-right: 30px;\n}\n\n.shape-box {\n  font-size: 16px;\n  line-height: 16px;\n  // height: 125px;\n  overflow: hidden;\n}\n\n.show {\n  overflow: visible;\n  height: auto;\n}\n\n.more-btn {\n  color: #555555;\n  font-size: 16px;\n  margin: auto;\n  text-decoration: none;\n}\n\n.footer-btn {\n  height: 65px;\n  text-decoration: none;\n}\n\n.fixed-row {\n  position: fixed;\n  bottom: 20px;\n  width: 90vw;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  // margin-left: 7px;\n  // margin-right: 27px;\n  z-index: 1000000;\n}\n\n.pdbtn {\n  margin-bottom: 50px;\n}\n\n.shape-text {\n  padding: 12px;\n}\n\n.search-fixed-row {\n  border-radius: 20px;\n  -webkit-box-shadow: 0px 2px 26px -6px #b9b7b7;\n  -moz-box-shadow: 0px 2px 26px -6px #b9b7b7;\n  box-shadow: 0px 2px 26px -6px #b9b7b7;\n  text-align: right;\n}\n\n.inner-box {\n  text-align: center;\n  padding: 0;\n  border: 1px solid var(--ion-color-secondary) !important;\n  border-radius: 80px;\n}\n\n.to-text {\n  padding-top: 10px;\n}\n\n.mobile-bg {\n  //background-color: #ececec;\n  --background: #ececec !important;\n}\n\n.small-font {\n  font-size: 14px !important;\n}\n\n.int-outerdiv {\n  width: 82vw;\n  margin: auto;\n  display: block;\n  border-radius: 0 0 18px 18px;\n  overflow: hidden;\n  border: 0.5px solid var(--ion-color-secondary);\n  padding: 10px px;\n}\n\n.searchBtnHeight {\n  height: 65px !important;\n}\n\n.header-diamond {\n  height: 3vh;\n  margin-top: 4px;\n  margin-right: 16px;\n}\n\n.header-diamond-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n@media only screen and (max-width: 768px) {\n  .header-diamond-image {\n    height: auto; /* Adjust as necessary */\n    min-height: 2.7vh; /* Ensure it takes full screen height */\n  }\n}\n\n.plain-text {\n  color: #ffff;\n  font-size: 3.5vh;\n  font-weight: bolder;\n  font-family: 'Trajan Pro Regular';\n}\n\n.s-icon {\n  color: var(--ion-color-primary) !important;\n}\n\n.colored-text {\n  color: var(--ion-color-primary) !important;\n  font-size: 2.1vh;\n  margin-left: 20px;\n}\n\n.delete-search {\n  color: var(--ion-color-primary) !important;\n  font-size: 2.1vh;\n}\n\n.disabledDivBtn {\n  background: #ddd !important;\n}\n\n.bottom-line {\n  border-bottom: 1px solid #0000001a;\n  padding: 10px 0px;\n}\n\n.reset_btn {\n  color: var(--ion-color-label-color);\n  --background: var(--ion-color-background-button);\n  // --ripple-color: #f2f2f2;\n}\n\n.fixedWidthBtn {\n  width: 8.5vw;\n}\n\n// .reset_btn.ion-activated {\n//   --background: #f2f2f2;\n// }\n\n// .shape-container{\n//   display: flex;\n//   flex-flow: column wrap;\n//  // align-content: space-between;\n//   //counter-reset: items;\n//   height: 125px;\n// }\n\n// /* Re-order items into 3 rows */\n// .inner-box:nth-child(3n+1) { order: 1; }\n// .inner-box:nth-child(3n+2) { order: 2; }\n// .inner-box:nth-child(3n)   { order: 3; }\n\n// @media all and (device-width: 991px) {\n//   .fixedWidthBtn {\n//     width: 18vw !important;\n//   }\n// }\n\n@media (min-width: 992px) and (max-width: 1240px) {\n  .fixedWidthBtn {\n    width: 12vw !important;\n  }\n\n  .finishing_parameters_tab {\n    display: block;\n  }\n\n  .finishing_parameters_desc {\n    display: none;\n  }\n\n  .carat_specific_tab_show {\n    display: inline-block;\n  }\n\n  .carat_specific_tab_hide {\n    display: none;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 991px) {\n  .fixedWidthBtn {\n    width: 16vw !important;\n  }\n\n  .contentDiv {\n    padding: 0px 2vw 20px 2vw;\n  }\n\n  .onPageTitle {\n    font-size: 28px;\n    font-weight: 400;\n    margin-top: 16px;\n    margin-bottom: 10px;\n  }\n\n  .clsSPTitleHead {\n    font-size: 14px;\n    font-weight: 500;\n    margin-right: 8px;\n  }\n\n  .clsSPTitle {\n    font-size: 14px;\n    font-weight: 500;\n    margin-left: 4px;\n  }\n\n  .clsSPTitleSelected {\n    font-size: 14px;\n    font-weight: 500;\n    margin-right: 4px;\n  }\n\n  .bottom-line {\n    padding: 0px;\n  }\n\n  .search_textarea {\n    height: 42px;\n    width: 30vw;\n  }\n\n  ::ng-deep .search_textarea .textarea-wrapper .native-textarea {\n    padding: 10px 0px 0px !important;\n    height: 40px;\n  }\n\n  .clsShapeImg,\n  .clsShapeImgSelected {\n    .text {\n      padding: 4px 12px !important;\n      font-size: 14px;\n    }\n  }\n\n  // .searchCard {\n  //   width: 29vw;\n  // }\n\n  .searchCard_content {\n    padding: 12px 12px 12px 12px !important;\n  }\n\n  .finishing_parameters_tab {\n    display: block;\n  }\n\n  .finishing_parameters_desc {\n    display: none;\n  }\n\n  .carat_specific_tab_show {\n    display: inline-block;\n  }\n\n  .carat_specific_tab_hide {\n    display: none;\n  }\n\n  #finishing_parameters .clsSPTitleHead {\n    min-width: 9vw;\n    width: min-content;\n  }\n\n  .finishing_extra {\n    display: none;\n  }\n\n  .advanceTextCss {\n    font-size: 16px;\n  }\n\n  .option_container {\n    padding: 12px;\n  }\n\n  .bg-specific {\n    width: 100px;\n  }\n\n  .carat_specific_added .text {\n    padding: 6px 20px 6px 8px !important;\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 767px) {\n  #finishing_parameters .clsSPTitleHead {\n    min-width: 12vw;\n    width: min-content;\n  }\n\n  .searchCard {\n    margin: 20px 0px 60px 0px;\n  }\n\n  .search-btn {\n    right: 22px;\n  }\n\n  .fixedWidthBtn {\n    width: auto;\n  }\n}\n\n@media (min-width: 501px) and (max-width: 575px) {\n  .searchCard {\n    margin: 20px 0px 60px 0px;\n  }\n\n  .search-btn {\n    right: 34px;\n  }\n\n  .fixedWidthBtn {\n    width: auto;\n  }\n\n  .disInline_direction {\n    flex-direction: column;\n  }\n\n  #finishing_parameters .clsSPTitleHead {\n    min-width: 21vw;\n  }\n}\n\n.reset-img {\n  background-image: url('../../../../assets/images/reset.png');\n  background-position: center;\n  background-size: auto;\n  background-repeat: no-repeat;\n  // width: 5.2vw;\n  // text-align: center;\n  // //top: 11px;\n  // padding-top: 4px;\n}\n\n.clearBtnWithImage {\n  cursor: pointer;\n}\n\n.round-reset-btn {\n  border-radius: 80px;\n  height: 32px;\n  margin-top: 8px;\n  margin-right: 8px;\n  background: var(--ion-color-primary, #3880ff);\n}\n\n.savedSearchtitle {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ion-color-heading);\n  font-family: 'Trajan Pro Regular';\n}\n\n.reset-icon {\n  font-size: 25px;\n}\n\n@media (min-width: 0px) and (max-width: 575px) {\n  .left-color-div,\n  .right-color-div {\n    line-height: 34px;\n  }\n\n  .int-outerdiv {\n    border: 0px solid;\n  }\n\n  .shape-width-flex {\n    border-radius: 12px;\n    border: 1px solid var(--ion-color-secondary);\n  }\n\n  .shape-width-flex_mob {\n    border-radius: 0px 0px 25px 25px;\n    border: 1px solid var(--ion-color-secondary);\n  }\n\n  .shape-width-flex_mob::-webkit-scrollbar {\n    height: 0px;\n  }\n\n  .shape-width-flex::-webkit-scrollbar {\n    height: 0px;\n  }\n}\n\n.group_container::-webkit-scrollbar {\n  height: 0px;\n}\n\n.carat_specific_add_btn {\n  --border-radius: 50%;\n  margin: 6px;\n  width: 40px;\n  height: 40px;\n}\n\n.carat_specific_added {\n  margin: 8px 4px;\n  position: relative;\n}\n\n.carat_specific_added .text {\n  padding: 6px 20px 6px 8px !important;\n  font-size: 12px;\n}\n\n.remove-specific-carat {\n  color: #fff;\n  font-size: 16px;\n  position: absolute;\n  right: -2px;\n  top: 2px;\n  padding: 4px;\n}\n\n::ng-deep .ionic-selectable-value span {\n  display: flex;\n  gap: 4px;\n}\n\n.to-from_input,\n.to-from_input-mob {\n  padding: 0px !important;\n  text-align: center;\n}\n\n::ng-deep .to-from_input-mob .native-input.sc-ion-input-ios {\n  padding-left: 8px;\n}\n\nion-toolbar {\n  --padding-start: 0px;\n  --padding-end: 0px;\n  --padding-top: 0px;\n  --padding-bottom: 0px;\n}\n\n.footer-ios ion-toolbar:first-of-type {\n  border-top: none !important; /* Removes the border at the bottom */\n  --border-width: 0 !important; /* Ensure that any Ionic-specific border styles are also removed */\n}\n@media screen and (max-width: 575px) {\n  ::ng-deep ionic-selectable {\n    .ionic-selectable-inner {\n      .ionic-selectable-value {\n        display: flex;\n        justify-content: center;\n      }\n\n      .ionic-selectable-icon {\n        position: absolute;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
